import React, {useEffect, useState} from "react";
import { IProfile } from '../../../interface/IProfile.ts';
import { useProfileApi } from '../../../features/auth/hooks/use-profile-api.ts'
import { ApiResponseType } from "../../../features/api/types.ts";
import { useListsApi } from "../../../features/auth/hooks/use-lists-api.ts";
import { IOption } from "../../../interface/IOption.ts";
import Checkboxes from "../../Form/Checkboxes.tsx";
import Form from "../../Form/Form.tsx";
import ApiCheck from '../../Structure/ApiCheck.tsx';

const TabServices = ({
    profile,
    setProfile
}:{
    profile:IProfile
    setProfile: Function
}) => {
    const [servicesList, setServicesList] = useState<Array<any>>([]);
    const [servicesLoading, setServicesLoading] = useState<boolean>(true);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [responseMessage, setResponseMessage] = useState<string>('');
    const [responseMessageClass, setResponseMessageClass] = useState<string>('');
    const { postProfile } = useProfileApi();
    const [errors, setErrors] = useState<any>({});
    const { getList } = useListsApi();
    const [apiErrors, setApiErrors] = useState<any>();
    
    const [unSavedChanges, setUnSavedChanges] = useState(false);
    
    const [formData, setFormData] = useState<IProfile>({
        services: profile.services ?? [],
    });

    const handleChange = (event, name = '', value = null) => {
        setFormData({ ...formData, [name ? name : event.target.name]: value ? value : event.target.value });
        !unSavedChanges && setUnSavedChanges(true);
    };

    const expectedAmountServices:number = 24;

    const handleSubmit = (event) => {
        event.preventDefault();
        setUnSavedChanges(false);
        setIsLoading(true);

        let postedData:{services:Array<string>} = {
            services: [],
        };
        let serviceIds = formData.services!.map(el => {
            return el.value;
        });
        postedData.services = serviceIds;

        setErrors({});
        postProfile(postedData).then(res => {
            setIsLoading(false);
            if (res.type === ApiResponseType.OK) {
                if (res.payload.success)  {
                    setResponseMessage('Erfolgreich gespeichert');
                    setResponseMessageClass('success');
                    setProfile({...profile, ...postedData});
                    setTimeout(() => {
                        setResponseMessage('');
                    }, 5000);
                }
            } else {
                let errors = res.payload.errors!;
                if (!errors.general_error) {
                    setResponseMessage('Fehler. Bitte korrigieren Sie den Fehler und versuchen Sie es erneut.');
                    setResponseMessageClass('error');
                }
                setErrors(errors);
            }
        })
    }

    useEffect(() => {
        getList('services').then(res => {
            let optionList:Array<IOption> = [];
            if (res) {
                res.forEach((item:any) => {
                    optionList.push({
                        value: item.id,
                        label: item.label
                    });
                });
                setServicesList(optionList);
                let servicesFromOptions:Array<IOption> = [];
                servicesFromOptions = optionList.filter(singleServiceOption => {
                    return profile.services?.includes(singleServiceOption.value);
                });
                setFormData({ ...formData, services: servicesFromOptions });
                setServicesLoading(false);
            }
        }).catch(() => {
            setApiErrors({
                errors: 'Der Server ist aktuell nicht erreichbar. Bitte probieren Sie es später erneut.'
            });
            setServicesLoading(false);
        });
    }, []);

    return (
        <div className="single-tab-item">
            <Form
                unSavedChanges={unSavedChanges}
                handleSubmit={handleSubmit}
                isLoading={isLoading}
                responseMessage={responseMessage}
                responseMessageClass={responseMessageClass}
                generalErrors={ errors.general_error ? errors.general_error : null}
                intro="Bitte markieren Sie die von Ihnen angebotenen Beratungs- und Dienstleistungsangebote. Die Auswahl ist auch Basis für die Suche auf der FPSB-Webseite."
            >
                { servicesLoading ? (
                    <div className="form-group checkboxes no-label">
                        <div className="checkbox-inputs-wrapper">
                            {[...Array(expectedAmountServices)].map((k,i) =>
                                <div className="single-checkbox" key={'s_' + i}>
                                    <input type="checkbox" disabled />
                                    <label><div className="checkbox-loader"></div></label>
                                </div>
                            )}
                        </div>
                    </div>
                ) : (
                    <ApiCheck errors={apiErrors ? apiErrors : null}>
                        <Checkboxes
                            name='services'
                            onChange={(item:IOption, wasChecked:boolean) => {
                                if (wasChecked) {
                                    let x = formData.services.filter(el => {
                                        return el.value !== item.value
                                    });
                                    handleChange(null, 'services', x);
                                } else {
                                    let x = structuredClone(formData.services);
                                    x.push(item);
                                    handleChange(null, 'services', x);
                                }
                            }}
                            value={formData?.services}
                            options={servicesList}
                            error={errors['services']}
                        />
                    </ApiCheck>
                ) }
            </Form>
        </div>
    )
}

export default TabServices;